import { State } from 'interfaces/state'
import {
  FeedFilterYourPopup,
  FeedFilterYourPopupStateProps,
  FeedFilterYourPopupDispatchProps,
  FeedFilterYourPopupOwnProps,
} from 'components/features/socialFeed/FeedfilterPopup/FeedFilterYourPopup'
import { connectOptionally, OptionalRendererProps, NO_RENDER, createPositiveRendererProps } from 'tangle-shared'
import {
  hidePopupFeedFilterActionCreator,
  registerPopupFeedFilterTimeoutActionCreator,
  changeSocialProfileStepActionCreator,
  selectFeedFilterActionCreator,
} from 'actions/feedActions'
import { memberFeedInfoSelector } from 'selectors/feedSelectors'
import { yourPeergroupSelector } from 'selectors/peergroupSelectors'
import { setShownSidebarPaneActionCreator } from 'actions/sidebarActions'
import { MapDispatchToPropsFunction } from 'react-redux'

const mapStateToProps = (state: State, _ownProps: FeedFilterYourPopupOwnProps): OptionalRendererProps<FeedFilterYourPopupStateProps> => {
  const feedMember = memberFeedInfoSelector(state)
  const peergroup = yourPeergroupSelector(state)

  if (!feedMember || !peergroup) {
    return NO_RENDER()
  }

  return createPositiveRendererProps({
    hidePopupTimeoutId: state.app.feed.filterPopup.hideTimeoutId,
    username: feedMember.username || null,
    peergroup,
  })
}

const mapDispatchToProps: MapDispatchToPropsFunction<FeedFilterYourPopupDispatchProps> = (dispatch) => ({
  onHidePopup: () => dispatch(hidePopupFeedFilterActionCreator()),
  onRegisterHideTimeout: (timeoutId: number) => dispatch(registerPopupFeedFilterTimeoutActionCreator(timeoutId)),
  onCreateNickname: () => dispatch(changeSocialProfileStepActionCreator('form')),
  onViewPosts: () => {
    dispatch(selectFeedFilterActionCreator({ type: 'your-posts' }))
    dispatch(setShownSidebarPaneActionCreator(null))
  },
})

export const FeedFilterYourPopupContainer = connectOptionally<
  FeedFilterYourPopupStateProps,
  FeedFilterYourPopupDispatchProps,
  FeedFilterYourPopupOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedFilterYourPopup)
